import { stringify } from 'query-string';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { AboutDataDto, AboutDataListDto, AboutDto, AboutDtoImpl } from './aboutdto';

export class AboutBuilder
{
    constructor(private aboutList: any)
    {
        if(aboutList.aboutList === undefined)
        {
            throw new NoDataException("About data doesnt exists");
        }
    }

    buildAll(): AboutDto[]
    {
        return this.parseAboutDetailsResponse();
    }
    
    private parseAboutDetailsResponse(): AboutDto[]
    {
        console.log("parseAboutDetailsResponse() invoked");
        let listOfAbout: AboutDto[] = [];
        
        let aboutDto = null;
       
        this.aboutList.aboutList.forEach((aboutItem: any) =>
        {
            aboutDto = new AboutDtoImpl();
            aboutDto.setAboutHeader(aboutItem.header);
            console.log("parseAboutDetailsResponse()",stringify(aboutItem.header));

            // faqDto.setFaqAnswer(faqItem.answer[0].list);
            
            let aboutDataList: AboutDataListDto[] = [];
            let aboutDataListDto = null;
            aboutItem.dataList.forEach((datalist: any) =>
            {
                console.log("parseAboutDetailsResponse() 2",stringify(datalist));

                aboutDataListDto = new AboutDataListDto();

                let aboutDataDto = null;
                let aboutListDto: AboutDataDto[] = [];
                datalist.data.forEach((data: any) =>
                {
                    console.log("parseAboutDetailsResponse() 3",JSON.stringify(data.icon_title));

                    aboutDataDto = new AboutDataDto();

                    aboutDataDto.setText(data.text);
                    aboutDataDto.setIconName(data.icon_title);
                    aboutDataDto.setIconPath(data.icon_name);
                    console.log("parseAboutDetailsResponse() 5",aboutDataDto);

                    aboutListDto.push(aboutDataDto);
                });

                aboutDataListDto.setData(aboutListDto);
                aboutDataList.push(aboutDataListDto);
            });

            aboutDto.setAboutDataList(aboutDataList);
            listOfAbout.push(aboutDto);
        });

        console.log("Ending About builder:",listOfAbout.length);
        return listOfAbout;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/about/aboutbuilder.ts